import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchInsurance, fetchIssue } from '../../api/quoteApi'

export const putInsurance = createAsyncThunk(
  'insurance/putIsurance',
  async (_, { getState, rejectWithValue }) => {

    const { insurance, coverage } = getState();

    const payload = {
      vehiculo: {
        no_serie: insurance.formValues.numSerie,
        no_motor: insurance.formValues.motor,
        no_placas: insurance.formValues.placa,
      }
    }
    const uuid = coverage.uuid;

    try {
      const data = await fetchInsurance({payload, uuid});

      if (data.success) {
        return data;
      } else {
        return rejectWithValue(data.message || 'Error al seleccionar el paquete');
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
   }
);

export const issuePolicy = createAsyncThunk(
  'insurance/issuePolicy',
  async (_, { getState, rejectWithValue }) => {
      try {
        const { coverage } = getState();
        const uuid = coverage.uuid;

        const response = await fetchIssue({ uuid });

        /*
        if (response.success) {
          const id_poliza = response.no_poliza;

          const message = {
            timestamp: new Date().toISOString(),
            type: 'POLICY_ISSUED',
            payload: { 
              id_poliza: id_poliza
            },
          }

          if (window.ReactNativeWebView && typeof window.ReactNativeWebView.postMessage === 'function') {
            window.ReactNativeWebView.postMessage(JSON.stringify(message));
          } else {
            console.warn('ReactNativeWebView.postMessage no está disponible');
          }
        }
        */

        if (response.success) {
          return response;
        } else {
          return rejectWithValue('Error al emitir la póliza');
        }
      } catch (response) {
        return rejectWithValue(response.message || 'Error inesperado al emitir póliza');
      }
    }
);

/*
export const sendPolicyMessage = createAsyncThunk(
  'insurance/sendPolicyMessage',
  async ({ idPoliza }, {getState, rejectWithValue }) => {
    try {
      const { coverage } = getState();
      const uuid = coverage.uuid;

      const message = {
        timestamp: new Date().toISOString(),
        type: 'POLICY_ISSUED',
        payload: { 
          id_poliza: uuid
        }
      };
      
      if (window.ReactNativeWebView && typeof window.ReactNativeWebView.postMessage === 'function') {
        window.ReactNativeWebView.postMessage(JSON.stringify(message));
        window.postMessage(JSON.stringify(message));
        return { success: true };
      } else {
        console.warn('ReactNativeWebView.postMessage no está disponible');
        return rejectWithValue('ReactNativeWebView no disponible');
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
*/

export const sendPolicyMessage = createAsyncThunk(
  'insurance/sendPolicyMessage',
  async ({ idPoliza }, { getState, rejectWithValue }) => {
    try {
      const { coverage } = getState();
      const uuid = coverage.uuid;

      const message = {
        timestamp: new Date().toISOString(),
        type: 'POLICY_ISSUED',
        payload: { id_poliza: uuid }
      };

      const isRNWebView =
        window.ReactNativeWebView &&
        typeof window.ReactNativeWebView.postMessage === 'function';

      if (isRNWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify(message));
      } else {
        const target = window.parent !== window ? window.parent : window;
        target.postMessage(JSON.stringify(message), '*');

        console.log('[sendPolicyMessage] enviado a', target === window ? 'self' : 'parent', message);
      }

      return { success: true };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


const initialState = {
    
  formValues: {
    motor: '',
    numSerie: '',
    placa: '',
  },

  validValues: {
    motor: false,
    numSerie: false,
    placa: false,
  },

  idPoliza: null,

  Error: null,

  status: 'idle'
};

const insuranceSlice = createSlice({
  name: 'insurance',
  initialState,
  reducers: {
        setFormValue: (state, action) => {
            const { field, value } = action.payload;
            state.formValues[field] = value;
        },
        setValidValue: (state, action) => {
          const { field, isValid } = action.payload;
          state.validValues[field] = isValid;
        },
        resetError: (state) => {
            state.Error = null;
        },
        resetProcess: () => {
            return {
            ...initialState,
            };
        }
    },
    extraReducers: (builder) => {
    builder
      .addCase(putInsurance.pending, (state) => {
        state.status = 'loading';
        state.errorMessage = null;
      })
      .addCase(putInsurance.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(putInsurance.rejected, (state, action) => {
        state.status = 'failed';
        state.errorMessage = action.payload || 'Error inesperado';
      })
      .addCase(issuePolicy.pending, (state) => {
        state.status = 'loading';
        state.errorMessage = null;
      })
      .addCase(issuePolicy.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.idPoliza = action.payload.no_poliza;
      })
      .addCase(issuePolicy.rejected, (state, action) => {
        state.status = 'failed';
        state.errorMessage = action.payload || 'Error al emitir la póliza';
      });
    },
});

export const { 
  setFormValue,
  setValidValue,
  resetError, 
  resetProcess 
} = insuranceSlice.actions;

export default insuranceSlice.reducer;